import { FC } from 'react'
import { AppTypeSelector } from 'widgets/AppTypeSelector'
import { withModalHOC } from 'shared/HOCs/withModalHOC'
import { ThemeToggle } from 'features/ThemeToggle'

import { ModalContainer, SettingsContainer } from './styles'

export const Settings: FC = () => {
  return (
    <SettingsContainer>
      <ModalContainer>
        <AppTypeSelector />
        <ThemeToggle />
      </ModalContainer>
    </SettingsContainer>
  )
}

export const SettingsModal = withModalHOC(Settings)
